export default [
 
    {
      title: 'Sender ID',
      route: 'sender-id',
      icon: 'TwitchIcon',
    }
]